import * as Yup from "yup";
import { KeyValueMap } from "../../../../../../../../../redux/slices/appState/models";
import { ProjectRaiseInvoicePODetailsFormKey } from "../../../../../../../modelsAndSchemas/Models";
import { INPUT_LIMIT } from "../../../../../../../../../helpers/constants";

export const ProjectRaiseInvoiceModalSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [ProjectRaiseInvoicePODetailsFormKey.localInvoiceNumber]: Yup.string()
      .optional()
      .test(
        "is-valid",
        commonValidationMessages.onlyAlphanumericSpacesAndHyphenAllowed,
        (value) =>
          !value || INPUT_LIMIT.ALPHA_NUMERIC_WITH_DASH_AND_SPACE.test(value),
      )
      .default(""),
    [ProjectRaiseInvoicePODetailsFormKey.projectPONumber]: Yup.string(),
    [ProjectRaiseInvoicePODetailsFormKey.projectCurrentPOBalance]: Yup.string(),
    [ProjectRaiseInvoicePODetailsFormKey.projectPOShortage]: Yup.string(),
    [ProjectRaiseInvoicePODetailsFormKey.projectInvoiceDate]:
      Yup.string().required(commonValidationMessages.requiredValidation),
    [ProjectRaiseInvoicePODetailsFormKey.projectPaymentTerms]:
      Yup.string().required(commonValidationMessages.requiredValidation),
  });
